<template>
  <div class="position-relative">
    <header class="header bg-light fixed-top" :class="{ activeheader: isShadow }">
      <NavBar />
    </header>
    <transition>
      <main class="main">
        <router-view> </router-view>
      </main>
    </transition>
    <footer>
      <Footer />
    </footer>
  </div>
</template>
<script>
import NavBar from "@/components/navBar.vue";
import Footer from "@/components/footer.vue";

export default {
  components: {
    NavBar,
    Footer,
  },
  data() {
    return {
       isShadow:false
    };
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
  },
  methods: {
    scrollToTop() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 100) {
        this.isShadow = true
      }
      else{
         this.isShadow = false
      }
    },
  },
};
</script>>
<style lang="less">
  a{
    color: #343a40;
  }
  a:hover{
    text-decoration:none!important;
  }
  .lead {
    font-size: 1rem!important;
    font-weight: 400!important;
    line-height: 2.1!important;
  }
.activeheader{
  box-shadow: 0 0.1rem 0.4rem 0.1rem rgba(213,211,211);
}
.header {
  height: 3.5rem;
}
.main {
  margin-top: 3.5rem;
}
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 500ms;
  position: absolute;
}
.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
</style>



// WEBPACK FOOTER //
// src/view/layout/layout.vue